module.exports = [{"languageId":"english","locale":"en","name":"English","icon":"gb"},{"languageId":"spanish","locale":"es","name":"Spanish","icon":"es"},{"languageId":"portuguese","locale":"pt","name":"Portuguese","icon":"pt"}]


//////////////////
// WEBPACK FOOTER
// ./routes/app/components/Navigation/Header/languageData.json
// module id = 1328
// module chunks = 0